// @flow
import { useState } from "react";
import { debounce } from "lodash";

export const useDebounce = (fn: (...args: any) => any, timeout: number) => {
  const [{ debounced }] = useState({ debounced: debounce(fn, timeout) });
  return debounced;
};
